import { releaseNotesVersion } from "./releaseNotes.js";
import AccountingDocumentService from "../../accounting/shared/documentInfrastructure/AccountingDocumentService.js";

// We store in localStorage an object whose key is a release notes id
// and value is a hash of release notes. Having the same last seen
// hash and release note version means that the last release notes has
// already been viewed.
export const localStorageId = "release-notes-viewed-version";

/**
 * Service responsible for all data exchange required by the release
 * notesdocument. The receiver coordinates other services and
 * repositories.
 */
export default class ReleaseNotesDocumentService extends AccountingDocumentService {
	shouldShowLastVersion() {
		const lastSeenVersion = window.localStorage.getItem(localStorageId);
		return lastSeenVersion !== releaseNotesVersion;
	}

	markLastVersionAsSeen() {
		window.localStorage.setItem(localStorageId, releaseNotesVersion);
	}
}
